import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    marginBottom: 20,
    marginTop: 20,
  },
  heading: {
    paddingBottom: 10,
    marginBottom: 10,
    fontWeight: 800,
    fontSize: theme.fonts.sizes.font18PX,
    borderBottom: `1px solid ${theme.colors.light.ghostWhite}`,
  },
  buttonGroup: {
    display: 'flex',
    marginTop: 8,
    height: '3rem',
    marginBottom: 26,
  },
  title: {
    fontSize: theme.fonts.sizes.font16PX,
    fontWeight: 700,
  },
}));
